import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Loader,
  ModalComponentWrapper,
  ResultContent,
} from '@/shared/components';
import { useDepositWithdrawAssetsDictionary } from '@/shared/api';
import { useModalStore } from '@/shared/lib';
import UnsuccessDocumentsIcon from '@/shared/assets/unsuccess-documents-icon.svg?react';
import { hasOperationMethodData } from '../lib';

interface OperationMethodDataGateProps {
  title: string;
  methodKey: string;
  assetCode?: string;
  onReady: () => void;
}

export function OperationMethodDataGate({
  title,
  methodKey,
  assetCode,
  onReady,
}: OperationMethodDataGateProps) {
  const { t } = useTranslation();
  const { closeDialog } = useModalStore();
  const isReadyCalled = useRef(false);

  const { depositWithdrawAssetsData, depositWithdrawAssetsLoading } =
    useDepositWithdrawAssetsDictionary();

  const hasMethodData = hasOperationMethodData(
    depositWithdrawAssetsData?.value,
    methodKey,
    assetCode
  );

  useEffect(() => {
    if (hasMethodData && !isReadyCalled.current) {
      isReadyCalled.current = true;
      onReady();
    }
  }, [hasMethodData, onReady]);

  const isLoading = depositWithdrawAssetsLoading || hasMethodData;

  return (
    <ModalComponentWrapper title={title}>
      {isLoading ? (
        <Loader />
      ) : (
        <ResultContent
          title={t('common.errorTitle')}
          description={t('common.operationUnavailable')}
          isSuccess={false}
          icon={<UnsuccessDocumentsIcon className="size-[6.4rem]" />}
          titleClassName="headline4"
          descriptionClassName="p4"
          className="h-auto"
          buttonText={t('common.close')}
          buttonVariant="secondary"
          onClick={closeDialog}
        />
      )}
    </ModalComponentWrapper>
  );
}
